import { createSlice } from '@reduxjs/toolkit';

export type workspaceMembersState = {
  users: any[];
  isLoaded: boolean;
};

const initialState: workspaceMembersState = { users: [], isLoaded: false };

const workspaceMemberSlice = createSlice({
  name: 'members',
  initialState: initialState,
  reducers: {
    handleSetMembers(state, action) {
      state.users = action.payload;
      state.isLoaded = true;
    }
  }
});

export const { handleSetMembers } = workspaceMemberSlice.actions;

export const workspaceMemberReducers = workspaceMemberSlice.reducer;
